import React from 'react';

const Ticket = ({ticketLink}) =>
    (
        <div className="widget atbd_widget widget-card">
            <div className="widget-body">
                <a href={ticketLink.href} className="btn btn-outline-secondary btn-block" title={ticketLink.description} aria-label="book-ticket">
                    {ticketLink.description}
                </a>
            </div>
        </div>
    );

export default Ticket;
